import React from 'react'
import { Result } from 'antd'
import { Button } from 'ui/styled'
import config from 'constants/config'
import StyledWrapper from './styled'

const SsoErrorPage = () => {
  const text = new URLSearchParams(window.location.search).get('text')

  return (
    <StyledWrapper>
      <Result
        title="SSO authentification has failed"
        subTitle={text}
        extra={
          <Button
            btntype="primary"
            data-test="goToOktaBtn"
            href={config.OKTA_DEFAULT}
          >
            Go to OKTA
          </Button>
        }
      />
    </StyledWrapper>
  )
}

export default SsoErrorPage
